<script setup lang="ts">
import type { VisibilityOption } from '@/features/privacy/usePrivacy';

type Props = {
  context: 'read' | 'edit';
  display?: 'horizontal' | 'vertical';
  isSelected?: boolean;
  toggle?: () => void;
  visibilityOption: VisibilityOption;
};

const props = withDefaults(defineProps<Props>(), {
  display: 'vertical',
});
</script>

<template>
  <v-card
    :tag="props.context === 'read' ? 'div' : 'button'"
    class="flex flex-col py-4 px-12 relative"
    :class="props.display === 'horizontal' ? 'items-start' : 'items-center'"
    @click="props.toggle"
  >
    <v-icon
      v-if="props.context === 'edit'"
      class="absolute top-4 start-4"
      :icon="`${isSelected ? 'fas' : 'fat'} fa-circle-dot`"
      :color="isSelected ? 'primary' : 'icon'"
    ></v-icon>

    <div
      class="flex items-center w-full"
      :class="props.display === 'horizontal' ? 'flex-row' : 'flex-col'"
    >
      <v-icon
        size="x-large"
        class="ma-4"
        :icon="props.visibilityOption.icon"
        color="iconSolid"
      ></v-icon>

      <h3 class="text-h2" :class="props.display === 'horizontal' ? 'me-2' : 'mb-4'">
        {{ $t(props.visibilityOption.title) }}
      </h3>

      <p class="text-body-2" :class="props.display === 'horizontal' ? 'me-2' : 'mb-4'">
        {{ $t(props.visibilityOption.subtitle) }}
      </p>

      <p class="text-body-2" :class="props.display === 'horizontal' ? 'me-2' : 'mb-4'">
        {{ $t(props.visibilityOption.description) }}
      </p>
    </div>
  </v-card>
</template>
